import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const productMix = [
  { name: 'Shampoo', value: 22.0, color: '#DC2626' },
  { name: 'Body Wash', value: 18.5, color: '#D4AF37' },
  { name: 'Toothpaste', value: 16.2, color: '#2563EB' },
  { name: 'Soap (Bar)', value: 15.1, color: '#059669' },
  { name: 'Lotion', value: 13.8, color: '#7C3AED' },
  { name: 'Others', value: 14.4, color: '#EA580C' },
];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
      <p className="font-caption text-sm font-semibold" style={{ color: '#0F172A' }}>{payload?.[0]?.name}</p>
      <p className="font-data text-xs" style={{ color: '#475569' }}>{payload?.[0]?.value}% of total</p>
    </div>
  );
};

export default function ProductMixChart() {
  return (
    <div className="card p-4 lg:p-6 chart-panel-depth">
      <h3 className="font-heading font-semibold text-lg lg:text-xl mb-1" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Product Mix</h3>
      <p className="font-caption text-sm mb-4" style={{ color: '#475569' }}>Revenue contribution by category</p>
      <div className="w-full h-48 sm:h-52 md:h-56 lg:h-64" aria-label="Product mix pie chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={productMix} cx="50%" cy="50%" innerRadius="45%" outerRadius="70%" paddingAngle={3} dataKey="value">
              {productMix?.map((entry) => (
                <Cell key={entry?.name} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: '13px', fontFamily: 'var(--font-caption)', color: '#1A1A2E', fontWeight: 600 }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}